import { IAC_ICON_SIZE_DEFAULT, IacIcon, IacIconSize } from '@iac-types';

export function getIconSize(name: IacIcon): IacIconSize {
  // postfix of icon indicates the size
  // postfix is the part of the icon name after the last minus (only numbers)
  // if no postfix is given, the default 18 is used

  const postfix = name.substring(name.lastIndexOf('-') + 1);

  const size = parseInt(postfix, 10);

  switch (size) {
    case 16:
      return 16;
    case 18:
      return 18;
    case 20:
      return 20;
    case 24:
      return 24;
    default:
      return IAC_ICON_SIZE_DEFAULT;
  }
}
